export enum RouteTypeColor {
  PREDEFINED = '#D633FF',
  DYNAMIC = '#336CFF',
  NORMAL = '#326295',
}
